import { useEffect } from "react";
import { API } from "@/App";
import axios from "axios";

export function usePushNotifications(token) {
  useEffect(() => {
    if (!token || !("serviceWorker" in navigator) || !("PushManager" in window)) return;

    const subscribe = async () => {
      try {
        const registration = await navigator.serviceWorker.ready;
        const existing = await registration.pushManager.getSubscription();
        if (existing) {
          // Already subscribed, save to backend
          await axios.post(`${API}/push/subscribe`, { subscription: existing.toJSON() }, {
            headers: { Authorization: `Bearer ${token}` }
          });
          return;
        }

        // Get VAPID key from backend
        const res = await axios.get(`${API}/push/vapid-key`);
        const vapidKey = res.data.public_key;
        if (!vapidKey) return;

        // Request permission
        const permission = await Notification.requestPermission();
        if (permission !== "granted") return;

        // Subscribe
        const sub = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(vapidKey)
        });

        // Save to backend
        await axios.post(`${API}/push/subscribe`, { subscription: sub.toJSON() }, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } catch (err) {
        console.log("Push subscription failed:", err);
      }
    };

    // Delay subscription to not block initial render
    const timer = setTimeout(subscribe, 3000);
    return () => clearTimeout(timer);
  }, [token]);
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
